// eslint-disable-next-line no-shadow
export enum ElearningPermissions {
  EDIT_ELEARNING = 'admin.coursebuilder.elearning.edit',
  CREATE_NEW_ELEARNING = 'admin.coursebuilder.newelearning.create',
  VIEW_ELEARNING = 'admin.coursebuilder.elearning.view',
  SELECT_THEME = 'admin.coursebuilder.theme.select',
  EDIT_ELEARNING_SETUP = 'admin.coursebuilder.elearningsetup.edit',
  VIEW_ELEARNING_NOTES = 'admin.coursebuilder.elearning.notes.view',
  REPLICATE_MODULE_SETTINGS_MODULE = 'admin.coursebuilder.modulesettings.module.replicate',
  DELETE_MODULE_SETTINGS_MODULE = 'admin.coursebuilder.modulesettings.module.delete',
  TOOGLE_MOBILE = 'admin.coursebuilder.mobile.toggle',
  EDIT_MOBILE = 'admin.coursebuilder.mobile.edit',
  PREVIEW_MOBILE = 'admin.coursebuilder.mobile.preview',
  EDIT_RESOURCE = 'admin.coursebuilder.resource.edit',
  PREVIEW_DRAFT = 'admin.coursebuilder.draft.preview',
  PUBLISH_REVIEW = 'admin.coursebuilder.review.publish',
  PUBLISH_LIVE = 'admin.coursebuilder.live.publish',
  PUBLISH_BULK = 'admin.coursebuilder.bulk.publish',
  EDIT_TEMPLATES = 'admin.coursebuilder.templates.edit',
}
